import styled from 'styled-components'
import BackPageHeader from './BackPageHeader'

const HideBackTextOnMobileHeader = styled(BackPageHeader)`
	p {
		@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
			display: none;
		}
	}
`

export default HideBackTextOnMobileHeader
